import { queryOptions } from '@tanstack/react-query';
import { authService } from './services/authService';

export const authQueries = {
  all: () => ['auth'] as const,
  me: () =>
    queryOptions({
      queryKey: [...authQueries.all(), 'me'] as const,
      queryFn: () => authService.me(),
      // Revalida o status a cada montagem (SPEC 1.3 D-2 — inativação reflete na
      // sessão viva) e garante refetch limpo após o callback OIDC. /me é leve.
      staleTime: 0,
      retry: false,
    }),
};
